import { BaseClient } from './BaseClient'

export class AdvicesApi extends BaseClient {
  getAdvices = this.createRequest({
    url: '/api/advices',
    method: 'get',
  })
  getAdvicesSeo = this.createRequest({
    url: '/api/advices-page-home',
    method: 'get',
  })
}
